export default __webpack_public_path__ + "static/media/img-login.62bb6b7b.svg";